import React, { useState } from 'react';

import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';

import './Footer.scss';
const Footer = () => {
  const [formData, setformData] = useState({name: "" , email: '' , message: ''});
  const [isFormSubmitted , setisFormSubmitted ] = useState(false);
  const [loading, setLoading] = useState(false);

  const { name, email , message} = formData;

  const handleChangeInput= (e) => {
    const {name , value} = e.target;

    setformData({ ...formData , [name]: value })
  }
  const handleSubmit = () => {
    setLoading(true);

    const concat = {
      _type: 'concat',
      name: formData.name,
      message: message,
    }

    client.create(concat)
      .then(() => {
        setLoading(false);
        setisFormSubmitted(true);
      })
  }
  return (
    <>
      <h2 className='head-text'>Take a coffe & chat with me</h2>

        <div className="app__footer-cards">
          <div className="app__footer-card">
            <img src={images.email} alt="email" />
            <a href="mailto:kkrishna22572@gmail.com" className='p-text'>kkrishna22572@gmail</a>
          </div>
          <div className="app__footer-card">
            <img src={images.mobile} alt="mobile" />
            <a href="tel: +91 9964146123" className='p-text'>+91 9964146123</a>
          </div>

        </div>
        {!isFormSubmitted ? 
          (<div className="app__footer-form app__flex">
            <div className="app__flex">
              <input className='p-text' placeholder='Your Name' name ="username" value={name} onChange={handleChangeInput} />
            </div>
            <div className="app__flex">
              <input className='p-text' placeholder='Your email' name ="email" value={email} onChange={handleChangeInput} />
            </div>
            <div>
              <textarea
                className='p-text'
                placeholder='Your Message'
                value={message}
                name="message"
                onChange={handleChangeInput}
              />
            </div>
            <button type='button' className='p-text' onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
          </div>)
        : (<div>
          <h3 className='head-text'>Thank you for getting in touch</h3> 
          </div>)
        }
    </>
  )
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg'
)
